<template>
    <div class="block-list-container">
      <h3>Block Übersicht</h3>
      <div class="search-container">
        <span class="material-icons">search</span>
        <input 
          type="text" 
          v-model="searchTerm" 
          placeholder="Suchen..." 
          class="search-input" 
        />
      </div>
      <p v-if="filteredBlocks.length === 0">Keine Ergebnisse gefunden.</p>
      <ul>
        <li 
          v-for="block in filteredBlocks" 
          :key="block.id" 
          @click="selectBlock(block.id)"
          @dblclick="setDbBlock(block.id)"
          :class="{ selected: selectedBlockId === block.id }"
        >
          <div class="previewBlockButton" v-if="!block.parent_id" @click.stop="deleteBlock(block.id)"><span class="material-symbols-outlined" >delete</span></div>
       <!--  <div class="previewBlockButton" v-if="!Object.values(blockDataCache[block.id])[0].parent" @click.stop="deleteBlock(block.id)"><span class="material-symbols-outlined" >delete</span></div> -->
          <div class="block-type" v-html="highlight(block.type)"></div>
          <div class="block-id" v-html="highlight(block.data.props.name || `${block.type}-Block`)"></div>
          <div class="block-id">ID: <span v-html="highlight(block.id.toString())"></span></div>
          <div class="block-id">Mail: <span v-html="highlight(block.emailTitle)"></span></div>
          <div class="block-id">Folder: <span v-html="highlight(block.folderName)"></span></div>
          <div v-if="selectedBlockId === block.id && blockDataLoaded(block.id)" class="preview-container">
            <component 
                  :is="getComponentType(block.type)"
                  :data="Object.values(blockDataCache[block.id])[0].data"
                  :emailData="blockDataCache[block.id]"
              ></component>
          </div>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  import { ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex'; // Vuex-Store importieren
  import { insertBlockFromDb } from '@/utils/db/insertBlockFromDb';
  import { watch } from 'vue';
  import HeadingBlock from '../blocks/HeadingBlock.vue';
  import HtmlBlock from '../blocks/HtmlBlock.vue';
  import TextBlock from '../blocks/TextBlock.vue';
  import SpacerBlock from '../blocks/SpacerBlock.vue';
  import ColumnsContainerBlock from '../blocks/ColumnsContainerBlock.vue';
  import ImageBlock from '../blocks/ImageBlock.vue';
  import ButtonBlock from '../blocks/ButtonBlock.vue';
  import DividerBlock from '../blocks/DividerBlock.vue';
  import ContainerBlock from '../blocks/ContainerBlock.vue';
  import RulesetBlock from '../blocks/RulesetBlock.vue';

  
  export default {
    name: 'BlockList',
    setup() {
      const store = useStore(); // Vuex-Store-Instanz holen
      const blocks = ref([]); // Liste aller Blöcke
      const searchTerm = ref(''); // Suchbegriff
      const selectedBlockId = ref(null); // Aktuell ausgewählter Block

      // Cache für bereits geladene Block-Daten
      const blockDataCache = ref({});

      // Funktion prüft, ob Daten für einen Block bereits geladen sind
      const blockDataLoaded = computed(() => (id) => !!blockDataCache.value[id]);
  
      // API-Aufruf: Hole alle Blöcke
      const fetchBlocks = async () => {
        try {
          const response = await fetch('https://html-creator.demo.cartago.com/api/blocks');
          blocks.value = await response.json();
          console.log(blocks.value)
        } catch (error) {
          console.error('Fehler beim Abrufen der Blöcke:', error);
        }
      };
  
      // Block auswählen
      const selectBlock = (blockId) => {
        selectedBlockId.value = selectedBlockId.value === blockId ? null : blockId;
      };
  
      // Block an den Store senden
      const setDbBlock = async (blockId) => {
      try {
        const response = await fetch(`https://html-creator.demo.cartago.com/api/blocks/${blockId}`);
        const  dbBlock = await response.json();
        const boilerplate = insertBlockFromDb(dbBlock, blockId)
        //Dispatch an den Vuex-Store
        store.dispatch('addBoilerplate', boilerplate);
        }
        catch (error) {
          console.error('Fehler beim Abrufen der Details:', error);
        };
      };
  
      // Gefilterte Blöcke basierend auf dem Suchbegriff
      const filteredBlocks = computed(() => {
        if (!searchTerm.value) return blocks.value;
        const term = searchTerm.value.toLowerCase();
        return blocks.value.filter(block => 
          block.type.toLowerCase().includes(term) ||
          (block.data.props.name || `${block.type}-Block`).toLowerCase().includes(term) ||
          block.emailTitle.toLowerCase().includes(term) ||
          block.folderName.toLowerCase().includes(term)
        );
      });
  
      // Highlighting-Funktion
      const highlight = (text) => {
        if (!searchTerm.value || !text) return text;
        const term = searchTerm.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape RegExp
        const regex = new RegExp(`(${term})`, 'gi');
        return text.replace(regex, '<span style="background-color: #cccc">$1</span>');
      };

      const getComponentType = (type) => {
        const components = {
          Heading: HeadingBlock,
          Text: TextBlock,
          Spacer: SpacerBlock,
          ColumnsContainer: ColumnsContainerBlock,
          Image: ImageBlock,
          Container: ContainerBlock,
          Button: ButtonBlock,
          Divider: DividerBlock,
          Html: HtmlBlock,
          Ruleset: RulesetBlock
      }
      return components[type] || 'div';
      };

      const blockData = async (blockId) => {
      if (!blockDataCache.value[blockId]) {
        try {
          const response = await fetch(`https://html-creator.demo.cartago.com/api/blocks/${blockId}`);
          const dbBlock = await response.json();
          const block = insertBlockFromDb(dbBlock, blockId);
          console.log(block)
          //blockDataCache.value[blockId] = Object.values(block)[0].data; // ✅ Speichern im Cache
          blockDataCache.value[blockId] = block;
        } catch (error) {
          console.error('Fehler beim Abrufen der Details:', error);
        }
      }
      return blockDataCache.value[blockId];
      };

      const deleteBlock = async (id) => {
        console.log(id)
        await fetch(`https://html-creator.demo.cartago.com/api/delete-block/${id}`, {method:'DELETE'});
        fetchBlocks()
      }

      watch(selectedBlockId, async (newId) => {
        if (newId && !blockDataCache.value[newId]) {
          await blockData(newId); // Ruft blockData auf und speichert es im Cache
        }
      });
  
      onMounted(fetchBlocks); // Blöcke beim Mounten laden
  
      return {
        blocks,
        searchTerm,
        filteredBlocks,
        selectedBlockId,
        selectBlock,
        deleteBlock,
        setDbBlock,
        highlight,
        getComponentType,
        blockData,
        blockDataCache,
        blockDataLoaded,
      };
    },
  };
  </script>
  
  <style scoped>
  .block-list-container {
    max-width: 600px;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f9f9f9;
    text-align: left;
  }
  
  .search-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .material-icons {
    font-size: 20px;
    margin-right: 8px;
    color: #555;
  }
  
  .search-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
  
  li {
    padding: 10px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    position: relative;
  }

  .previewBlockButton{
  padding: 2px;
  position: absolute; 
  top: 25px; 
  right: 0px;
  color:#ccc;
}
.previewBlockButton:hover{
  color: black;
  cursor: pointer
}
  
  li.selected {
    background-color: #e6f7ff;
  }
  
  .block-type {
    font-weight: bold;
  }
  
  .preview-container {
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 5px;
    margin-top: 5px;
    white-space: pre-wrap;
    max-width:600px;
    pointer-events: none;
  }
  
  </style>
  
  